import { render } from "./AcceptOrderDetails.vue?vue&type=template&id=f8fb182c&scoped=true"
import script from "./AcceptOrderDetails.vue?vue&type=script&lang=js"
export * from "./AcceptOrderDetails.vue?vue&type=script&lang=js"

import "./AcceptOrderDetails.vue?vue&type=style&index=0&id=f8fb182c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8fb182c"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QInnerLoading,QImg,QBtn});
